import React, { forwardRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = forwardRef(({
  value,
  onChange,
  placeholder = "Écrivez votre message...",
  minHeight = "200px",
  modules = null,
  className = ""
}, ref) => {
  // Toolbar par défaut (minimaliste)
  const defaultModules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"]
    ]
  };

  // Utiliser les modules personnalisés ou les modules par défaut
  const editorModules = modules || defaultModules;

  return (
    <>
      <style>
        {`
          .minimal-quill-editor .ql-toolbar {
            border: none !important;
            border-bottom: 1px solid #e2e8f0 !important;
            background: #f8fafc !important;
            padding: 8px !important;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
          }
          .minimal-quill-editor .ql-container {
            border: none !important;
            font-size: 14px !important;
            min-height: ${minHeight} !important;
          }
          .minimal-quill-editor .ql-editor {
            padding: 16px !important;
          }
          .minimal-quill-editor .ql-editor.ql-blank::before {
            color: #9ca3af !important;
            font-style: normal !important;
          }
          .minimal-quill-editor .ql-toolbar button {
            width: 28px !important;
            height: 28px !important;
          }
          .minimal-quill-editor .ql-toolbar button:hover {
            background: #e0e7ff !important;
            border-radius: 4px !important;
          }
          .minimal-quill-editor .ql-toolbar button.ql-active {
            background: #e0e7ff !important;
            color: #4f46e5 !important;
          }
          .minimal-quill-editor {
            border-radius: 7px !important;
            overflow: hidden !important;
            background: white !important;
          }
        `}
      </style>
      <ReactQuill
        ref={ref}
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`minimal-quill-editor ${className}`}
        modules={editorModules}
      />
    </>
  );
});

RichTextEditor.displayName = 'RichTextEditor';

export default RichTextEditor;
